import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["default", "shown", "defaultText", "customText"]

  updateHiddenFields(event) {
    const selectedOption = event.target.value

    switch (selectedOption) {
      case "default":
        this.defaultTextTarget.classList.remove("hidden")
        this.customTextTarget.classList.add("hidden")
        this.defaultTarget.value = "true"
        this.shownTarget.value = "true"
        break
      case "custom":
        this.defaultTextTarget.classList.add("hidden")
        this.customTextTarget.classList.remove("hidden")
        this.defaultTarget.value = "false"
        this.shownTarget.value = "true"
        break
      case "none":
        this.defaultTextTarget.classList.add("hidden")
        this.customTextTarget.classList.add("hidden")
        this.defaultTarget.value = "false"
        this.shownTarget.value = "false"
        break
    }
  }
}
